document.addEventListener("DOMContentLoaded", () => {

  const sliders = document.querySelectorAll("[data-review-slider]");

  sliders.forEach((section) => {

    const track = section.querySelector(".reviews-track");
    const slides = Array.from(section.querySelectorAll(".reviews-slide"));

    const nextBtn = section.querySelector(".reviews-arrow--next");
    const prevBtn = section.querySelector(".reviews-arrow--prev");

    const dotsContainer = section.querySelector(".reviews-dots");

    if (!track || slides.length === 0) return;


    let currentIndex = 0;
    let autoplay;


    function getSlidesPerView() {

      if (window.innerWidth <= 749) {
        return 1;
      }

      if (window.innerWidth <= 990) {
        return 2;
      }

      return 3;

    }



    function getMaxIndex() {

      return Math.max(
        slides.length - getSlidesPerView(),
        0
      );

    }



    function updateSlider() {

      const slideWidth =
        slides[0].getBoundingClientRect().width +
        20;


      track.style.transform =
        `translateX(-${currentIndex * slideWidth}px)`;


      updateDots();

    }



    function createDots() {

      dotsContainer.innerHTML = "";


      const total =
        getMaxIndex() + 1;


      for (let i = 0; i < total; i++) {

        const dot =
          document.createElement("button");


        dot.className =
          "review-dot";


        dot.setAttribute(
          "aria-label",
          `Go to slide ${i + 1}`
        );


        dot.addEventListener(
          "click",
          () => {

            currentIndex = i;

            updateSlider();

          }
        );


        dotsContainer.appendChild(dot);

      }


      updateDots();

    }



    function updateDots() {

      const dots =
        dotsContainer.querySelectorAll(".review-dot");


      dots.forEach((dot, index) => {

        dot.classList.toggle(
          "active",
          index === currentIndex
        );

      });

    }



    function nextSlide() {

      if (
        currentIndex >= getMaxIndex()
      ) {

        currentIndex = 0;

      } else {

        currentIndex++;

      }


      updateSlider();

    }



    function previousSlide() {

      if (
        currentIndex <= 0
      ) {

        currentIndex = getMaxIndex();

      } else {

        currentIndex--;

      }


      updateSlider();

    }



    if (nextBtn) {

      nextBtn.addEventListener(
        "click",
        nextSlide
      );

    }


    if (prevBtn) {

      prevBtn.addEventListener(
        "click",
        previousSlide
      );

    }



    /* Autoplay */


    function startAutoplay() {

      autoplay =
        setInterval(
          nextSlide,
          10000
        );

    }


    function stopAutoplay() {

      clearInterval(
        autoplay
      );

    }



    section.addEventListener(
      "mouseenter",
      stopAutoplay
    );


    section.addEventListener(
      "mouseleave",
      startAutoplay
    );



    /* Touch swipe */


    let startX = 0;


    let endX = 0;



    track.addEventListener(
      "touchstart",
      (event) => {

        startX =
          event.touches[0].clientX;

      },
      { passive:true }
    );



    track.addEventListener(
      "touchend",
      (event) => {

        endX =
          event.changedTouches[0].clientX;


        const difference =
          startX - endX;


        if (
          Math.abs(difference) > 50
        ) {

          if (difference > 0) {

            nextSlide();

          } else {

            previousSlide();

          }

        }

      }
    );



    window.addEventListener(
      "resize",
      () => {

        currentIndex = 0;

        createDots();

        updateSlider();

      }
    );



    createDots();

    updateSlider();

    startAutoplay();


  });

});